<template>
  <div>
    <section class=" container section is-main-section">
      <div>
        <v-card-component title="Cycle Configuration">
          <v-col>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsConfiguration' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
          <v-row>
            <v-col>
              <v-row>
                <v-col cols="12" lg="4" md="6">
                  <span class="body-2 font-weight-medium"> One Round Allocated Days <span class="error--text ml-1">*</span></span>
                  <v-text-field @input="calculateCycle" v-model="oneRound" required class="my-0 py-1" type="number" min="1" max="20" @keydown="preventDecimal"
                  :error-messages="oneRoundAllocationErr" >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="6">
                  <span class="body-2 font-weight-medium"> One Cycle Total Allocated Days <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="oneCycle" required class="my-0 py-1" type="number" disabled>
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4" md="6">
                  <span class="body-2 font-weight-medium"> One Cycle Completion Days <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="cycleCompletion" disabled required class="my-0 py-1">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row style="margin: 5px;">
            <button class="button is-success" @click="saveData()" type="submit" style="margin-top:20px;">Save</button>
            <button class="button is-success" @click="cancelData()" type="submit" style="margin-top:20px; margin-left: 15px;">Cancel</button>
          </v-row>
        </v-card-component>
      </div>
    </section>
    <section class=" container section is-main-section">
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="cycleConfiguration"
      ></v-data-table>
    </section>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'cycleConfiguration',
  components: {
    VCardComponent
  },
  data () {
    return {
      oneRound: '',
      oneCycle: '',
      cycleCompletion: '60 Days',
      headers: [
        {
          text: 'Configured Date',
          value: 'createdAt',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Configured By',
          value: 'createdBy',
          sortable: true,
          align: 'center'
        },
        {
          text: 'One Round Working Days',
          value: 'oneRoundAllocatedDays',
          sortable: true,
          align: 'center'
        },
        {
          text: 'One Cycle Working Days',
          value: 'oneCycleTotalAllocatedDays',
          sortable: true,
          align: 'center'
        }
      ],
      cycleConfiguration: [],
      oneRoundAllocationErr: ''
    }
  },
  created: async function () {
    await this.getCycleConfiguration()
  },
  methods: {
    calculateCycle: async function () {
      if (Number(this.oneRound) > 0 && Number(this.oneRound) < 21) {
        this.oneCycle = Number(this.oneRound) * 3
      } else {
        this.oneCycle = ''
      }
    },
    saveData: async function () {
      try {
        if (this.oneRound === '') {
          this.oneRoundAllocationErr = 'Please Enter Value'
          return
        } else if (this.oneRound <= 0) {
          this.oneRoundAllocationErr = 'Value must be greater than 0'
          return
        } else if (this.oneRound > 20) {
          this.oneRoundAllocationErr = 'Value must be 20 or less'
          return
        } else {
          this.oneRoundAllocationErr = ''
        }

        let response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/cycleConfiguration/addCycleConfiguration`,
          {
            'oneRoundAllocatedDays': this.oneRound,
            'oneCycleTotalAllocatedDays': this.oneCycle,
            'oneCycleCompletionDays': 60
          }
        )
        if (response.status === 200) {
          this.oneRound = ''
          this.oneCycle = ''
          this.getCycleConfiguration()
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: 'Record Saved Successfully',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        console.log(e, 'error')
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getCycleConfiguration: async function () {
      let response = await http.get(
        `${constants.API_URL}/api/amsScheduling/configuration/cycleConfiguration/getCycleConfiguration`
      )

      this.cycleConfiguration = response.data
      this.oneRound = this.cycleConfiguration[0].oneRoundAllocatedDays
      this.oneCycle = this.cycleConfiguration[0].oneCycleTotalAllocatedDays
      for (const item of this.cycleConfiguration) {
        item.createdAt = item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : ''
      }
    },
    cancelData: async function () {
      this.oneRound = ''
      this.oneCycle = ''
    },
    preventDecimal (event) {
      // Prevent typing if the key is a decimal point
      if (event.key === '.' || event.key === ',' || event.key === 'e' || event.key === 'E' || event.key === '-' || event.key === '--') {
        event.preventDefault()
      }
    }
  }
}
</script>
